import { PatientProfileRequestModalSettings } from "@/Patient/Models/Settings/PatientProfileRequestModalSettings";

export class PatientProfileRequestModalSettingsModel {
    public isHiddenFromCumulativePatientProfile: boolean;

    public static fromCacheModel(patientProfileRequestModalSettings: PatientProfileRequestModalSettings): PatientProfileRequestModalSettingsModel {
        if (!patientProfileRequestModalSettings)
            return null;

        return {
            isHiddenFromCumulativePatientProfile: patientProfileRequestModalSettings.IsHiddenFromCumulativePatientProfile
        };
    }

    public static toCacheModel(patientProfileRequestModalSettings: PatientProfileRequestModalSettingsModel): PatientProfileRequestModalSettings {
        if (!patientProfileRequestModalSettings)
            return null;

        return {
            IsHiddenFromCumulativePatientProfile: patientProfileRequestModalSettings.isHiddenFromCumulativePatientProfile
        };
    }
}
